import {getRequest} from "@services/api/axiosHandler";
import {getQuantity, getRoomQuantity} from "@services/helpers/ruleHandler";
import {filterUnitEquipment, valveFilter} from "@services/articles/filters";

import Article from "@models/helpers/Article";
import ArticleHasFeature from "@models/helpers/ArticleHasFeature";
import Accessorygroup from "@models/helpers/Accessorygroup";
import ArticlesHasAccessorygroup from "@models/helpers/ArticlesHasAccessorygroup";
import DevicepackagesHasArticle from "@models/helpers/DevicepackagesHasArticle";
import ArticleHasChild from "@models/helpers/ArticleHasChild";
import Articledetail from "@models/helpers/Articledetail";
import File from "@models/helpers/File";
import Countryprice from "@models/helpers/Countryprice";
import Rule from "@models/helpers/Rule";
import Documentfile from "@models/helpers/Documentfile";

import Unit from "@models/building/Unit";
import Room from "@models/building/Room";
import Valve from "@models/airvolumes/Valve";
import Systemselection from "@models/airvolumes/Systemselection";
import StoredArticle from "@models/articles/StoredArticle";
import StoredRoomArticle from "@models/articles/StoredRoomArticle";

export async function getArticles(reset = false) {
  if (!reset && Article.query().get().length > 0) return;
  if (reset == "login") {
    // Reload Prices, Details and Documents
    getRequest("article")
      .then((response) => {
        Countryprice.create({
          data: response.data.countryprice,
        });
        Documentfile.create({
          data: response.data.documentfile,
        });
        Articledetail.create({
          data: response.data.articledetails,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    return;
  }
  getRequest("article")
    .then((response) => {
      Article.create({
        data: response.data.articles,
      });

      ArticleHasFeature.create({
        data: response.data.articleHasFeature,
      });

//            Feature.create({
//                data: response.data.feature,
//            });

      Accessorygroup.create({
        data: response.data.accessorygroups,
      });

      ArticlesHasAccessorygroup.create({
        data: response.data.articlesHasAccessorygroup,
      });

      DevicepackagesHasArticle.create({
        data: response.data.devicepackagesHasArticles,
      });

      ArticleHasChild.create({
        data: response.data.articlesHasChilds,
      });

      Articledetail.create({
        data: response.data.articledetails,
      });

      File.create({
        data: response.data.documentfile,
      });

      Countryprice.create({
        data: response.data.countryprice,
      });

      Rule.create({
        data: response.data.rules,
      });

      Documentfile.create({
        data: response.data.documentfile,
      });
    })
    .catch((error) => {
      console.error(error);
    });
}

export function setDeviceEquipments(unitId, deviceId) {
  // get device childs which have rule with rule_name = quantity
  deleteDeviceEquipments(unitId);

  // check if device has status noDevice then return
  if (StoredArticle.query().where('unit_id', unitId).where('accessorygroup_id', 1).where('quantity', (quantity) => quantity >= 1).where('status', 'noDevice').exists()) {
    return
  }


  const articles = Article.query()
    .whereHas("parent", (query) => {
      query.where("articles_id", deviceId);
    })
    .whereHas("rules", (query) => {
      query.where("rule_name", "quantity");
    })
    .with(["rules"])
    .get();

  // loop through articles and set quantity
  articles.forEach((article) => {
    //get quantity rule from article.rules
    const quantityRule = article.rules.find(
      (rule) => rule.rule_name == "quantity"
    );
    if (!quantityRule) return;
    const quantity = getQuantity(
      quantityRule,
      unitId,
      article.getAccessorygroupId()
    );
    // store article in StoredArticle
    StoredArticle.insert({
      data: {
        article_id: article.id,
        unit_id: unitId,
        accessorygroup_id: article.getAccessorygroupId(),
        quantity: quantity,
      },
    });
  });
}

function deleteDeviceEquipments(unitId) {
  // get all accessorygroups with parent_group_id = 103
  const accessorygroups = Accessorygroup.query()
    .where("parent_group_id", 103)
    .get();
  accessorygroups.forEach((accessorygroup) => {
    // get all articles from StoredArticle with accessorygroup.id and unitId and delete them
    let articles = StoredArticle.query()
      .where("unit_id", unitId)
      .where("accessorygroup_id", accessorygroup.id)
      .get();
    articles.forEach((article) => {
      article.$delete();
    });
  });
}

export function setUnitEquipments(unitId) {
  const unit = Unit.query().where("id", unitId).first();
  const pipeAmmount = unit.getPipesAmmount();

  // check if unit ventilationMeasure is not 3 or 4 then return
  if (unit.ventilationMeasure != 3 && unit.ventilationMeasure != 4) return
  if (unit.equipmentUpdate == false) return
  if (unit.equipmentUpdate === 'loaded') {
    // check if one StoredArticle with unitId and accessorygroup.id [16, 17, 18, 19, 20, 21, 23, 24, 25, 26, 27, 28, 29] and quantity >= 1 exists
    if (!StoredArticle.query().where('unit_id', unitId).where('accessorygroup_id', (accessorygroup) => [16, 17, 18, 19, 20, 21, 23, 24, 25, 26, 27, 28, 29].includes(accessorygroup)).where('quantity', (quantity) => quantity >= 1).exists()) {
      unit.equipmentUpdate = true
    }
  }

  const rooms = Room.query().where('unitId', unitId).where('airType', 1).orWhere('airType', 2).get()
  rooms.forEach((room) => {
    setValves(room.id, unit.equipmentUpdate)
  })
  const equipmentAccessorygroups = []
  const accessorygroups = Accessorygroup.query().where('parent_group_id', 9).orWhere('parent_group_id', 10).orWhere('parent_group_id', 11).get()
  accessorygroups.forEach((accessorygroup) => {
    if (unit.equipmentUpdate !== 'loaded') {
      deleteUnitEquipments(unitId, accessorygroup.id)
    }
    // get Articles with accessorygroup.id and rule with rule_name = quantity
    const articles = Article.query()
      .whereHas("accessorygroup", (query) => {
        query.where("accessorygroups_id", accessorygroup.id);
      })
      .whereHas("rules", (query) => {
        query.where("rule_name", "quantity");
      })
      .with(["rules", "accessorygroup", "features"])
      .get();

    let articleInGroup = false;

    let dn = null;
    let dnDistributors = [];
    if (accessorygroup.id == 22) {
      // get device and all distrubutors (16,17) from unit
      const device = StoredArticle.query()
        .where("unit_id", unitId)
        .where("accessorygroup_id", 1)
        .where("quantity", (quantity) => quantity >= 1)
        .with(["article.features"])
        .first();
      const distributors = StoredArticle.query()
        .where("unit_id", unitId)
        .where(
          "accessorygroup_id",
          (accessorygroup) => accessorygroup == 16 || accessorygroup == 17
        )
        .where("quantity", (quantity) => quantity >= 1)
        .with(["article.features"])
        .get();
      // get dn from device
      if (device && device.article) {
        dn = device.article.getFeatureValueById(5);
      }
      // get value of feature 28 of every distributor
      distributors.forEach((distributor) => {
        const dnDistributor = distributor.article.getFeatureValueById(28);
        if (dnDistributor && dn != dnDistributor)
          dnDistributors.push(dnDistributor);
      });
    }

    let distributors = null
    if (accessorygroup.id == 16 || accessorygroup.id == 17) {
      distributors = unit.distributorSelection(accessorygroup.id)
    }

    // check if stored device has status noDevice then return
    if (StoredArticle.query().where('unit_id', unitId).where('accessorygroup_id', 1).where('quantity', (quantity) => quantity >= 1).where('status', 'noDevice').exists()) {
      switch (parseInt(accessorygroup.id)) {
        case 16:
        case 17:
        case 22:
        case 23:
        case 24:
        case 25:
          return
      }
    }

    // loop through articles and set quantity
    articles.forEach((article) => {
      if (!filterUnitEquipment(article, unitId, pipeAmmount, accessorygroup.id, distributors))
        return;
      //get quantity rule from article.rules
      articleInGroup = true;
      const quantityRule = article.rules.find(
        (rule) => rule.rule_name == "quantity"
      );
      if (!quantityRule) return;
      if (accessorygroup.id == 22 && dnDistributors.length > 0) {
        quantityRule.dn = dn;
        quantityRule.dnDistributors = dnDistributors;
      }
      const quantity = getQuantity(quantityRule, unitId, accessorygroup.id);
      // store article in StoredArticle
      if (unit.equipmentUpdate !== 'loaded') {
        StoredArticle.insert({
          data: {
            article_id: article.id,
            unit_id: unitId,
            accessorygroup_id: accessorygroup.id,
            quantity: quantity,
          },
        })
      }
    })
    // if no article in group get all articles of accessorygroup and check if article without quantity is in group
    if (!articleInGroup) {
      const allArticles = Article.query()
        .whereHas("accessorygroup", (query) =>
          query.where("accessorygroups_id", accessorygroup.id)
        )
        .with(["accessorygroup", "features"])
        .get();
      if (
        allArticles.some((article) => {
          return filterUnitEquipment(
            article,
            unitId,
            pipeAmmount,
            accessorygroup.id
          );
        })
      ) {
        articleInGroup = true;
      }
    }
    if (articleInGroup) {
      equipmentAccessorygroups.push(accessorygroup.id);
    }
  });
  Unit.update({
    where: unitId,
    data: {
      equipmentUpdate: false,
      equipmentAccessorygroups: equipmentAccessorygroups,
    },
  });
}

function deleteUnitEquipments(unitId, accessorygroupId) {
  // get all articles from StoredArticle with accessorygroup.id and unitId and delete them
  let articles = StoredArticle.query()
    .where("unit_id", unitId)
    .where("accessorygroup_id", accessorygroupId)
    .get();
  articles.forEach((article) => {
    article.$delete();
  });
}

export function setValves(roomId, reset = false) {
  //const room = Room.find(roomId);
  const room = Room.query().whereId(roomId).has("valves").first();
  if (!room) return;

  if (reset !== 'loaded') {
    deleteValves(roomId, 14)
  }
  let articles = Article.query()
    .whereHas("accessorygroup", (query) => {
      query.where("accessorygroups_id", 14);
    })
    .whereHas("rules", (query) => {
      query.where("rule_name", "quantity");
    })
    .with(["rules", "features"])
    .get();

  let valve = Valve.query().where("roomId", roomId).first();
  let systemselection = Systemselection.query()
    .where("unitId", room.unitId)
    .first();

  let pipeProfile = 75;
  if (systemselection.pipeProfile == 2) {
    pipeProfile = 63;
  } else if (valve.pipesystem == 2) {
    pipeProfile = 51;
  }
  articles.forEach((article) => {
    if (!valveFilter(article, room, valve, pipeProfile)) return;
    //get quantity rule from article.rules
    const quantityRule = article.rules.find(
      (rule) => rule.rule_name == "quantity"
    );
    if (!quantityRule) return;
    const quantity = getRoomQuantity(quantityRule, room, 14);
    // store article in StoredArticle
    if (reset !== 'loaded') {
      StoredRoomArticle.insert({
        data: {
          article_id: article.id,
          room_id: roomId,
          accessorygroup_id: 14,
          quantity: quantity,
        },
      })
    }
    if (quantity > 0) {
      setValveEquipments(room, article.id, reset)
    }
  })
}

function deleteValves(roomId, accessorygroupId) {
  // get all articles from StoredArticle with accessorygroup.id and unitId and delete them
  let articles = StoredRoomArticle.query()
    .where("room_id", roomId)
    .where("accessorygroup_id", accessorygroupId)
    .get();
  articles.forEach((article) => {
    article.$delete();
  });
}

export function setValveEquipments(room, articleId, reset) {
  if (reset !== 'loaded') {
    deleteValves(room.id, 15)
  }

  let articles = Article.query()
    .whereHas("parent", (query) => {
      query.where("articles_id", articleId);
    })
    .whereHas("rules", (query) => {
      query.where("rule_name", "quantity");
    })
    .with(["rules", "features"])
    .get();
  let valve = Valve.query().where("roomId", room.id).first();
  let systemselection = Systemselection.query()
    .where("unitId", room.unitId)
    .first();

  let pipeProfile = 75;
  if (systemselection.pipeProfile == 2) {
    pipeProfile = 63;
  } else if (valve.pipesystem == 2) {
    pipeProfile = 51;
  }
  const storeArticles = [];

  articles.forEach((article) => {
    if (!valveFilter(article, room, valve, pipeProfile)) return;
    //get quantity rule from article.rules
    const quantityRule = article.rules.find(
      (rule) => rule.rule_name == "quantity"
    );
    if (!quantityRule) return;
    const quantity = getRoomQuantity(quantityRule, room, 15);
    // store article in StoredArticle
    if (reset !== 'loaded') {

      StoredRoomArticle.insert({
        data: {
          article_id: article.id,
          room_id: room.id,
          accessorygroup_id: 15,
          quantity: quantity,
        },
      })
    }
  })
}
